// extracted by mini-css-extract-plugin
export default {"applePayButton":"Ga1d33b","applePayButtonText":"Gb44b6f","applePayButtonLogo":"G564f95"};